<div class="modal-header">
    <h4 class="modal-title"><strong>Estrategia - {{data.strategy.name}}</strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        
        <mat-divider></mat-divider>

        <div class="container-fluid mt-2">
            <div class="row col-12">
                <div class="col-md-6">
                   <label class="fw-bold">Seleccionar un Producto</label>
                   <!-- <select name="" id="" class="form-select mt-2" (change)="seleccionarOpcion($event)">
                        <option *ngFor="let producto of productos" [value]="producto.id" [selected]="producto.id === productSelect?.id">
                            {{producto.nombre}}
                        </option>
                   </select> -->
                   <mat-form-field class="w-100 sel-inv" appearance="outline">
						<input type="text" style="padding-top: 3px !important;"
							placeholder="Puedes buscar por nombre o SKU"
							matInput
							[formControl]="materialControl"
							[matAutocomplete]="auto"
                            (focus)="openDropdown()">
							<button
								*ngIf="materialControl.value"
								mat-icon-button
								matSuffix
								(click)="clearAutocomplete()"
								aria-label="Clear">
								<mat-icon>close</mat-icon>
							</button>
						<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="seleccionarOpcion($event)">
						<mat-option *ngFor="let producto of filteredOptions | async" [value]="producto">
							{{producto.product_name }}
						</mat-option>
						</mat-autocomplete>
					</mat-form-field>

                   <div *ngIf="productSelect != null" class="mt-3">
                        <label class="fw-bold">SKU</label>
                   </div>
                   <div>
                        <label>{{ productSelect?.legacy_sku }}</label>
                   </div>

                   <div *ngIf="productSelect != null" class="mt-1">
                    <label class="fw-bold">Descripción</label>
                    </div>
                    <div>
                        <label>{{ productSelect?.product_name }}</label>
                    </div>

                    <div *ngIf="productSelect != null" class="mt-1">
                            <label class="fw-bold">Último uso</label>
                    </div>
                    <div>
                        <label for="">{{ productSelect?.last_updated_on | date: 'dd/MM/yyyy' }}</label>
                    </div>

                </div>
                <div  *ngIf="productSelect != null" class="col-md-6">
                    <!-- <div class="pdf-container"><iframe id="pdf" name="pdf" width="100%" height="385px" [src]="getSourceURL(fileUrl)"></iframe></div> -->
                    <img [src]="fileUrl" alt="producto" />
                </div>
            </div>
        </div>
 
    </div>

    <div *ngIf="productSelect != null"  class="modal-footer mt-3 me-5">
        <button mat-flat-button class="bg-info text-white d-flex align-items-center" (click)="guardarSKU(data.strategy.id)" >
            <label style="cursor: pointer !important">Añadir </label>
            <mat-icon class="ms-1">add</mat-icon>
        </button>
    </div>
</mat-dialog-content>
